import { useEffect, useState, useCallback } from "react";
import { loadPurchaseInspectionList } from "../services/purchaseIndentService";

const usePurchaseInspectionList = (mode) => {
    const [inspectionList, setInspectionList] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);

    const fetchInspectionListSummary = useCallback(async () => {
        try {
            const payload = {
                p_companyid: localStorage.getItem("companyid"),
                p_mode: mode,
            };
            const data = await loadPurchaseInspectionList(payload);
            setInspectionList(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("Error loading inspection list:", error);
            setInspectionList([]);
        } finally {
            setIsLoaded(true);
        }
    }, []);

    useEffect(() => {
        if (!isLoaded) {
            fetchInspectionListSummary();
        }
    }, [isLoaded, fetchInspectionListSummary]);

    const refreshInspectionListSummary = () => {
        setIsLoaded(false); // Trigger useEffect to re-fetch
    };

    return {
        inspectionList,
        setInspectionList,
        refreshInspectionListSummary,
    };
};

export default usePurchaseInspectionList;
